import { customersConstants as constants } from '../../constants/customers';

const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedData: null,
  isError: null,
  error: '',
};

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_ALL:
      return { ...state, allData: action.data };
    case constants.GET_DATA:
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
      };
    case constants.GET_SELECT:
      return { ...state, selectedData: action.selectedData };
    case constants.GET_SELECT_CUSTOMER:
      return { ...state, selectedData: action.data };
    case constants.GET_FAILURE:
      return { ...state, isError: true, error: action.error };
    case constants.CLEAR_DATA:
      return { ...state, isError: null, error: '', selectedData: null };
    default:
      return { ...state };
  }
};
export default customerReducer;
